import type { User } from '@compass/client/types/user';
import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { UserAvatar, type UserAvatarProps } from '@/components/UserAvatar';

interface UserCellProps {
  user?: User;
  fallbackId?: string;
  size?: UserAvatarProps['size'];
  loading?: boolean;
  nameOnly?: boolean;
}

export const UserCell: React.FC<UserCellProps> = ({
  user,
  fallbackId,
  size = 'sm',
  loading,
  nameOnly,
}) => {
  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <Skeleton className="h-6 w-6 rounded-full" />
        <Skeleton className="h-4 w-24" />
      </div>
    );
  }

  if (!user && !fallbackId) {
    return <span className="text-sm text-muted-foreground">N/A</span>;
  }

  return (
    <div className="flex items-center gap-2 min-w-0">
      <UserAvatar
        name={user?.name}
        email={user?.email}
        userId={user?.id || fallbackId}
        size={size}
      />
      <div className="flex flex-col min-w-0">
        <span className="text-sm truncate">{user?.name || fallbackId}</span>
        {!nameOnly && user?.email && user.email !== user.name && (
          <span className="text-xs text-muted-foreground truncate">{user.email}</span>
        )}
      </div>
    </div>
  );
};
